import * as z from 'zod'
import { pickImagesRequiredSchema } from '~/shared/lib/schemas'

export const formSchema = z.object({
  passportPhotos: pickImagesRequiredSchema.refine(
    (images) => images.length >= 2,
    {
      message: 'Добавьте фотографию паспорта основного разворота и прописки',
    },
  ),
  drivingLicensePhotos: pickImagesRequiredSchema.refine(
    (images) => images.length >= 2,
    {
      message: 'Добавьте фотографии водительских прав с двух сторон',
    },
  ),
})

export type SchemaType = z.infer<typeof formSchema>

export type FormValues = SchemaType
